// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2KRsm","content":"ManualTimeModal_content__3QfQ-"};